exports.cs = {
  UNIFORM_INPUT_CHECKBOX_GDPR: {
    CHECK_REQUIRED: 'Musíte zaškrtnout.'
  }
}
